import React, { ReactElement } from "react";
import * as Ons from "react-onsenui";

interface Props {
  documentType: string;
  onClickDownload: () => void;
}

export function DocumentOverlayDownloadAction(props: Props): ReactElement {
  return (
    <Ons.Button
      key="download-file-button"
      className="VideoScreen__downloadFileButton with-icon"
      onClick={() => props.onClickDownload()}
    >
      <img src="assets/download-alt.svg" alt="Download" />
      <span>Download {props.documentType}</span>
    </Ons.Button>
  );
}
